import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import { pingCity } from "src/store/ui"
import ModalService from "src/modals"

import "./CoordChip.css"

/* A coordinate pair as a button (owner's R27, 2026-09-03: "any time we press [x-y] brackets, we
   should be able to highlight that city"). It selects the cell on the map — the small bar, not
   the city sheet — the same thing a coordinate clicked in chat does, so every "53-45" in a report,
   a battle header or a city sheet is the same door. */
const CoordChip = ({ col, row, className = "" }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const column = Number(col)
  const line = Number(row)
  return (
    <button
      type="button"
      className={`coord-chip ${className}`.trim()}
      title={t("map.goTo", { at: `${column}-${line}` })}
      onClick={(event) => {
        event.stopPropagation()
        // The small bar, not a sheet: whatever modal the chip was pressed in steps aside so the
        // map is what answers — the owner asked for the highlight, not the city view.
        ModalService.hideAll()
        dispatch(pingCity({ col: column, row: line }))
      }}
    >
      {column}-{line}
    </button>
  )
}

/* Text with every "col-row" inside it turned into a chip: the round report's lines are finished
   sentences, so the figures are found rather than passed in. */
export const withCoordChips = (text) =>
  String(text)
    .split(/(\b\d{1,3}-\d{1,3}\b)/g)
    .map((part, index) => {
      const match = /^(\d{1,3})-(\d{1,3})$/.exec(part)
      if (!match) return part
      return <CoordChip key={index} col={match[1]} row={match[2]} />
    })

export default CoordChip
